import { render, staticRenderFns } from "./patrimonio-chart.vue?vue&type=template&id=c0ac5d56&"
import script from "./patrimonio-chart.vue?vue&type=script&lang=js&"
export * from "./patrimonio-chart.vue?vue&type=script&lang=js&"
import style0 from "./patrimonio-chart.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0ac5d56')) {
      api.createRecord('c0ac5d56', component.options)
    } else {
      api.reload('c0ac5d56', component.options)
    }
    module.hot.accept("./patrimonio-chart.vue?vue&type=template&id=c0ac5d56&", function () {
      api.rerender('c0ac5d56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/consolidator/components/patrimonio-chart/patrimonio-chart.vue"
export default component.exports